import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoursewareService } from 'src/services/CoursewareService';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { ArticleEntryDisplayModel } from 'src/model/ContentEntry/ArticleEntryDisplayModel';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { globals } from '../shared/globals';
import { MetaService } from 'src/services/MetaService';
import { BaseComponent } from '../base.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-display-short-videos-content-entry',
  templateUrl: './display-short-videos-content-entry.component.html',
  styleUrls: ['./display-short-videos-content-entry.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class DisplayShortVideosContentEntryComponent extends BaseComponent implements OnInit, OnDestroy {
  public currentContentEntry: ArticleEntryDisplayModel;
  public breadcrumbs: Breadcrumb[] = [];
  public timeindex: string;

  constructor(private titleService: Title, private canonicalService: MetaService, private route: ActivatedRoute, private _router: Router, private coursewareService: CoursewareService, private alertService: AlertService) {
    super();
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  ngOnInit() {
    let alias = this.route.snapshot.paramMap.get('alias');
    this.timeindex = this.route.snapshot.paramMap.get('timeindex');
    if (!this.timeindex) {
      this.timeindex = this.route.snapshot.queryParams.TimeIndex;
    }

    this.coursewareService.getShortVideoEntry(alias).subscribe(data => {
      this.currentContentEntry = data;
      if (!this.currentContentEntry.Lineage) {
        this.currentContentEntry = null;
        let error: Error = data;
        this.alertService.error(error.Message);
        return;
      }
      let theUrl = globals.LOCALHOST + this._router.url + "/";

      this.canonicalService.addMetaTags(theUrl,
        this.currentContentEntry.RenderData.ContentEntryDescriptor.Information.Description,
        this.currentContentEntry.LogoUrl,
        this.currentContentEntry.Title,
        this.currentContentEntry.FacebookAppId);

      this.titleService.setTitle(this.currentContentEntry.Title);
      this.breadcrumbs = [{ Title: "Short-Videos", URL: "/shortvideosview" }, { Title: this.currentContentEntry.Lineage[0].TopicInformation.Title, URL: "/shortvideosview/" + this.currentContentEntry.Lineage[0].TopicInformation.Alias }, { Title: this.currentContentEntry.RenderData.ContentEntryDescriptor.Information.Title, URL: "/shortvideoscontentview/" + this.currentContentEntry.RenderData.ContentEntryDescriptor.Information.Alias }];
      this.canonicalService.createCanonicalURL(this._router.url, "/shortvideoscontentview/" + this.currentContentEntry.RenderData.ContentEntryDescriptor.Information.Alias);
      this.pushAllAds(3);

    });
  }
}
